import { API_URL, API_VERSION } from '@constants';
import { useData } from '@hooks/useData';
import { paths } from '../../types/api';
import { ApiError, useApiConfig } from '@hooks/useApiConfig';

const ENDPOINT_URL = '/str-stores/caes/all';

const ENDPOINT_URL_WITH_VERSION = `${API_VERSION}${ENDPOINT_URL}` as const;
type url = typeof ENDPOINT_URL_WITH_VERSION;

export interface GetMCaesResponse {
    data: paths[url]['get']['responses']['200']['content']['application/json'];
}

/**
 * Requests endpoint to get a user's stores CAES.
 */
export const useGetCaes = () => {
    const { getHeaders, handleCommonErrors } = useApiConfig();
    const { setAllCaes, setIsLoadingAllCaes } = useData();

    const request = async () => {
        setIsLoadingAllCaes(true);

        try {
            const response = await fetch(`${API_URL}${ENDPOINT_URL}`, {
                method: 'GET',
                headers: getHeaders(),
            });

            if (!response.ok) {
                const error = new Error() as ApiError;

                try {
                    const json = await response.json();
                    error.message = json.message;
                    error.errors = json.errors;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error: any) {
                    error.message = '';
                }

                error.statusCode = response.status;

                throw error;
            }

            const data: GetMCaesResponse = await response.json();

            setAllCaes(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
            handleCommonErrors(error);
        } finally {
            setIsLoadingAllCaes(false);
        }
    };

    return { request };
};
